export default __webpack_public_path__ + "static/experienceContainerBackground-ad3969596544357c6cd33614d4fff824.png";